/* Custom JS */
// (function initSortPreference() {
//       const sortDropdown = document.getElementById('SortBy_vertical');
//       if (!sortDropdown) return;

//       const url = new URL(window.location.href);
//       const urlParams = url.searchParams;
//       const savedSort = sessionStorage.getItem('userSortPreference');
//       const urlSort = urlParams.get('sort_by');

//       if (!urlSort && savedSort) {
//         urlParams.set('sort_by', savedSort);
//         window.location.href = url.toString();
//       }

//       if (urlSort) {
//         sessionStorage.setItem('userSortPreference', urlSort);
//       }

//       sortDropdown.addEventListener('change', (e) => {
//         sessionStorage.setItem('userSortPreference', e.target.value);
//       });
//     })();
// ReCahrge - Change submit button text

// Check for "discontinued"
window.discontinuedProduct = document.querySelector('.product__title.discontinued');


// window.addEventListener('load', function() {

//   function change_atc() {

//     if( document.getElementById('rc-radio2').checked ){
//       document.querySelector('.product-form .product-form__submit span').textContent = 'Subscribe';
//     } else { 
//       document.querySelector('.product-form .product-form__submit span').textContent = 'Add to bag';
//     }

//   }

//   if( document.getElementById('rc-radio2') ) {
//     change_atc();
//   }

//   // Monitor ReCharge radio buttons for change
//   var recharge_radios = document.querySelectorAll('.rc-radio__input');  
//   recharge_radios.forEach(radio => radio.addEventListener('change', () => change_atc()));

// });
  
// Activate ZenDesk on button click
window.addEventListener('load', function() {

  const live_chat_triggers = document.querySelectorAll('[data-live-chat-trigger]');

  live_chat_triggers.forEach(function(button) {
    button.addEventListener('click', e => {
      e.preventDefault();
      zE('messenger', 'open')
    });
  });

});

// Mobile Filter Trigger
document.addEventListener('click', (e) => {
  if (e.target.closest('.filtertrigger')) {
    console.log("Open Filter & Sort");
    document.querySelector('.mobile-facets__open-wrapper')?.click();
  }
});

// Footer Accordion
var show = function (elem) {
  elem.style.display = 'block';
};

var hide = function (elem) {
  elem.style.display = 'none';
};

var toggle = function (elem) {
  // If the element is visible, hide it
  if (window.getComputedStyle(elem).display === 'block') {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

};

document.addEventListener("DOMContentLoaded", function(event) { 
  if(window.innerWidth <= 750) {
  const accordion_titles = document.querySelectorAll('.footer-block--menu .footer-block__heading');

  accordion_titles.forEach(function(title) {
    title.addEventListener('click', event => {
      var content = title.parentNode.querySelector('.footer-block__details-content');
      toggle(content);
    });
  });
  }
});



// Apply Sign-up form to selected variants 
function addSignUpForm() {
  const selectedInput = document.querySelector('input[type="radio"][checked]');
  const selectedValue =  selectedInput.getAttribute('selected-value');
  const currentValue =  selectedInput.getAttribute('value');
  if( document.getElementById('atc-btn').disabled ){
    document.querySelector('.product-form .product-form__submit span').textContent = 'Sold Out';
    if( !selectedValue || currentValue !== selectedValue  ) return;
    document.querySelector('.prod-form-notification-container').style.display="block";
    document.querySelector('.product-form__quantity').style.display="none";
    document.querySelector('.product-form-container').style.display="none";
    // console.log("*** load on-selected");
  } 
  else{
    document.querySelector('.product-form .product-form__submit span').textContent = 'Add to Cart';
    if( !selectedValue ) return;
    document.querySelector('.prod-form-notification-container').style.display="none";
    document.getElementById('atc-btn').style.display="block";
    document.querySelector('.product-form__quantity').style.display="inline-block";
    document.querySelector('.product-form-container').style.display="inline-block";
    // console.log("*** load off-selected");
  }

}

if( document.getElementById('atc-btn') ) {
  addSignUpForm();
  // console.log("Initialize addSignUpForm()")
}
// Monitor ReCharge radio buttons for change
var variant_option = document.querySelectorAll('input[type="radio"]');

let containsOptionName = false; 

variant_option.forEach(option => option.addEventListener('change', function() {
  var selected_value =  option.getAttribute('selected-value');
  const productSubmitButton = document.querySelector('.product-form .product-form__submit span');
  
  if (option.getAttribute('value') === selected_value) {
    containsOptionName = true;
    if (productSubmitButton) productSubmitButton.textContent = 'Sold out';
    if( !selected_value ) return;
    document.querySelector('.prod-form-notification-container').style.display = "block";
    document.getElementById('atc-btn').style.display="none";
    document.querySelector('.product-form__quantity').style.display="none";
    document.querySelector('.product-form-container').style.display="none";
    // console.log("*** On change: display form ");
  }
  else {
    var product_form_notification_container = document.querySelector('.prod-form-notification-container');
    if (product_form_notification_container !== null) {
      if (productSubmitButton) productSubmitButton.textContent = 'Add to Cart';
      if( !selected_value ) return;
      product_form_notification_container.style.display = "none";
      document.getElementById('atc-btn').style.display="block";
      document.querySelector('.product-form__quantity').style.display="inline-block";
      document.querySelector('.product-form-container').style.display="inline-block";
    }
    
    // console.log("*** On change: hide form ");
  }
}));


  // Get the full URL
  const queryString = window.location.search;
  // console.log("Query String:", queryString); // Log the entire query string

  const url_params = new URLSearchParams(queryString);

  // Log what is retrieved for 'selling_plan'
  // console.log("Selling plan value:", params.get('selling_plan'));

  // Check if 'selling_plan=3102441624' is part of the URL
  if (url_params.get('selling_plan') === '3102441624') {
      // console.log("Selling plan is set to 3102441624 //Trynow Active True");
      window.trynowActive = true;
  } else {
      // console.log("Trynow Active False");
      window.trynowActive = false;
  }
  
document.querySelectorAll('a[href="#chat"]').forEach(anchor => {
  anchor.setAttribute("data-live-chat-trigger", "true"); 
});